import {EnvModel} from "./env-model";

const Production: EnvModel = {
  API_URL: "https://api.tomershefer.co.il",
};

export default Production;
